import React, { Suspense, useEffect } from 'react';
import { config } from '@guest-widgets/shared/src/config';
import { QueryRoute } from '@guest-widgets/shared/src/components/Router/QueryRoute';
import { QuerySwitch } from '@guest-widgets/shared/src/components/Router/QuerySwitch';
import { ProductDetailsSkeleton } from '@guest-widgets/shared/src/components/ProductDetailsSkeleton/ProductDetailsSkeleton';
import { useQueryRouter } from '@guest-widgets/shared/src/components/Router/QueryRouter';

import { Catalog } from './Catalog/Catalog';
import { useSettings } from './settingsContext';
import { FilterSearchParam } from './filtersContext/searchParamsMappers';

const ProductDetailsContainer = React.lazy(() => import('./ProductDetailsContainer'));

const { productIdQueryKey } = config;

export const Routes = () => {
  const {
    customerCode,
    locale,
    disableFeatures,
    enableFeatures,
    configuration,
    subId,
  } = useSettings();

  const { delete: deleteQueryProp } = useQueryRouter();

  useEffect(() => {
    return () => {
      Object.values(FilterSearchParam).forEach((filterPropName) => {
        deleteQueryProp(`${config.filterQueryPrefix}${filterPropName}`);
      });
      deleteQueryProp(config.productIdQueryKey);
    };
  }, []);

  return (
    <QuerySwitch>
      <QueryRoute query={productIdQueryKey}>
        <Suspense fallback={<ProductDetailsSkeleton />}>
          <ProductDetailsContainer
            customerCode={customerCode}
            locale={locale}
            disableFeatures={disableFeatures}
            enableFeatures={enableFeatures}
            subId={subId}
            configuration={configuration}
          />
        </Suspense>
      </QueryRoute>
      <QueryRoute>
        <Catalog />
      </QueryRoute>
    </QuerySwitch>
  );
};
